import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  Stack,
  Typography,
  CircularProgress,
  Paper,
  OutlinedInput,
  Grid,
  FormLabel,
  FormControlLabel,
  Select,
  MenuItem,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ReactDataGrid from "@inovua/reactdatagrid-community";
import "@inovua/reactdatagrid-community/base.css";
import "@inovua/reactdatagrid-community/theme/blue-light.css";
import "@inovua/reactdatagrid-community/theme/blue-dark.css";
import "@inovua/reactdatagrid-community/theme/amber-light.css";
import "@inovua/reactdatagrid-community/theme/amber-dark.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReportDataEditDialog from "./ReportDataEditDialog";
import SimpleDialog from "../components/SimpleDialog";
import ButtonTimKiem from "../components/ButtonTimKiem";
import PagingSearchCodeDialog from "../tools/PagingSearchCodeDialog";
import SearchFormColumnsDialog from "../tools/SearchFormColumnsDialog";
import GenerateCodeDialog from "../tools/GenerateCodeDialog";
import GenerateCodeReactDialog from "../tools/GenerateCodeReactDialog";

import {
  filterStyles,
  loadDataError,
  handleServerError,
  loadGridColumns,
  ReactDataGrid_i18n,
} from "../components/common";
import moment from "moment";
import SelectFilter from "react-select";
const myLib = require("../lib/MyLib");
const server = require("../lib/server");

const default_columns_grid = [
  {
    name: "ReportDataID",
    type: "number",
    header: "Mã số",
    headerAlign: "center",
    defaultWidth: 85,
  },
  {
    name: "ReportDataName",
    header: "Tên dữ liệu",
    headerAlign: "center",
    defaultWidth: 250,
  },
  {
    name: "ReportDataDesc",
    header: "Mô tả",
    headerAlign: "center",
    defaultWidth: 400,
  },

  {
    name: "NguoiCN",
    header: "Người CN",
    headerAlign: "center",
    defaultWidth: 120,
  },
  {
    name: "NgayCN",
    header: "Ngày CN",
    headerAlign: "center",
    defaultWidth: 120,
    render: (props) => moment(props.data.NgayCN).format("DD/MM/YYYY HH:mm"),
  },
];
//neu co dinh nghia trong global thi lay ra, khong thi lay default

const defaultSortInfo = {
  id: "TenCoQuan",
  name: "TenCoQuan",
  dir: 1,
  type: "string",
};
//tra ve index column tuy theo sort infor
const getSortColumnIndex = (columns, sortInfor) => {
  var find_index = 0;
  for (var i = 0; i < columns.length; i++) {
    var item = columns[i];
    if (item.name == sortInfor.name) {
      find_index = i;
      break;
    }
  }
  return find_index;
};

export default class ReportDataChonDialog extends React.Component {
  selectionCounter = 0; //dem so lan click chon thong tin tau
  lastClick = 0; //danh dau lan click truoc do' cua grid de xu ly double click

  constructor(props) {
    super(props);
    this.columns_grid =
      global.grid_columns !== undefined &&
      global.grid_columns[this.constructor.name] !== undefined
        ? global.grid_columns[this.constructor.name]
        : default_columns_grid;
    this.state = {
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorMessage: "", //mo ta loi neu co
      errorLog: "", //mo ta chi tiet loi
      loading_coquan: true, // co dang load ding danh muc nguon tin ko
      //searching
      search_loading: false,
      search_result: { data: [], count: 0 }, //ket qua tim kiem
      search_dataSource: [],
      search_error: false, //search co loi khong

      source_danhmuc: {},
      lastSortInfo: defaultSortInfo, //vi grid co trang thai sortinfo = null nen phai co cai nay
      sortInfo: defaultSortInfo,
      after: {
        PageIndex: 1,
        PageSize: 20,
        Ascending: true,
        SortBy: getSortColumnIndex(this.columns_grid, defaultSortInfo), //index column duoc sap xep
        //tieu chi tim kiem
        ReportDataName: "",
      },
      rowSelected: undefined, //dang lua chon row nao
      showEditDialog: false, // hien thi form cap nhat hay khong
      edittingRecord: undefined, //ban ghi chon de edit
      showConfirmXoa: false, //hien thi dialog xoa
      hasQuyen: global.hasRoles("R111"),
    };
  }

  componentDidMount() {
    this.loadDanhMuc();
  }
  //call khi user thay doi trang
  static getDerivedStateFromProps(nextProps, prevState) {
    return { open: nextProps.open };
  }
  handleClose(selection) {
    this.props.close(selection);
  }

  saveField = (fieldName, value) => {
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = true;
    s.canSaved = s.dataChanged;
    if (fieldName !== "PageIndex") {
      s.after.PageIndex = 1;
    }
    if (
      fieldName !== "PageSize" &&
      fieldName !== "PageIndex" &&
      fieldName !== "SortBy"
    ) {
      this.setState(this.state);
    } else {
      //neu lien quan den phan trang, sap xep thi load lai du lieu tu server
      this.setState(this.state, () => {
        this.doSearch();
      });
    }
    this.setState(this.state);
  };
  saveData = (obj) => {
    var old_changed = this.state.dataChanged;
    var s = this.state;
    s = { ...s, after: { ...s.after, ...obj } };
    s.dataChanged = true;
    s.canSaved = s.dataChanged;
    this.setState(s);
  };
  loadDanhMuc() {
    //load grid neu co
    loadGridColumns(this.constructor.name, default_columns_grid, (columns) => {
      this.columns_grid = columns;
      this.setState({ load_columns: true });
    });
  }
  //khi thay doi sap xep cot
  onSortInfoChange = (value) => {
    const newSort = value
      ? { type: value.type, name: value.name, dir: value.dir }
      : value;
    //ghi nhan vao sort by
    this.setState(
      {
        lastSortInfo: this.state.sortInfo
          ? this.state.sortInfo
          : this.state.lastSortInfo,
        sortInfo: newSort,
      },
      () => this.doSearch()
    );
  };
  loadData = ({ skip, limit, sortInfo }) => {
    var serverSortInfo = this.state.sortInfo
      ? this.state.sortInfo
      : this.state.lastSortInfo;

    var loader = new Promise((resolve, eject) => {
      server
        .post("ChiPhi/DoRequest", {
          Function: "Proc_Report_Data_Defines_Search",
          ThamSo: {
            ...this.state.after,
            PageIndex: skip / limit + 1,
            PageSize: limit,
            SortBy: getSortColumnIndex(this.columns_grid, serverSortInfo),
            Ascending: serverSortInfo.dir == 1,
          },
        })
        .then((response) => {
          this.setState({
            search_loading: false,
            search_error: false,
            search_result: {
              data: response.DataList,
              count: response.DataCount[0].Total,
            },
            rowSelected: undefined,
          });
          resolve({
            data: response.DataList,
            count: response.DataCount[0].Total,
          });
        })
        .catch((error) => {
          var message = "";
          var log = "";
          try {
            var obj = JSON.parse(error);
            message = obj.message;
            log = obj.traceLog;
          } catch (e) {
            message = error + "";
          }
          this.setState({
            search_loading: false,
            search_error: true,
            errorMessage: message,
            errorLog: log,
            search_result: { data: [], count: 0 },
            rowSelected: undefined,
          });
          resolve({ data: [], count: 0 });
        });
    });
    return loader;
  };
  doSearch = () => {
    var loader = this.loadData({
      skip: (this.state.after.PageIndex - 1) * this.state.after.PageSize,
      limit: this.state.after.PageSize,
      sortInfo: this.state.sortInfo,
    });
    this.setState({
      search_loading: true,
      search_dataSource: loader, //chi load sau khi co danh muc
      selectedRecord: {},
    });
  };
  render() {
    return (
      <Dialog
        open={this.props.open}
        fullWidth={true}
        maxWidth={"lg"}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <AppBar sx={{ position: "relative" }}>
            <Stack direction="row">
              <Typography
                sx={{ ml: 2, flex: 1, verticalAlign: "center" }}
                variant="h6"
                component="div"
              >
                Định ghĩa kho dữ liệu
              </Typography>
              <Stack direction="row" spacing={4}>
                {this.state.loading_data ? (
                  <CircularProgress color="warning" size={24} />
                ) : null}
                {this.state.saving ? (
                  <CircularProgress color="warning" size={24} />
                ) : null}
                {this.state.hasQuyen ? (
                  <>
                    <Button
                      color="success"
                      variant="contained"
                      onClick={() => {
                        this.setState({ showEditDialog: true });
                      }}
                    >
                      Thêm
                    </Button>
                    <Button
                      color="success"
                      variant="contained"
                      disabled={this.state.rowSelected === undefined}
                      onClick={() => {
                        this.setState({
                          showEditDialog: true,
                          edittingRecord: this.state.rowSelected,
                        });
                      }}
                    >
                      Sửa
                    </Button>
                    <Button
                      color="success"
                      variant="contained"
                      disabled={this.state.rowSelected === undefined}
                      onClick={() => {
                        this.setState({ showConfirmXoa: true });
                      }}
                    >
                      Xóa
                    </Button>
                  </>
                ) : null}
                {this.props.disableChon ? null : (
                  <Button
                    color="success"
                    variant="contained"
                    disabled={this.state.rowSelected === undefined}
                    onClick={() => {
                      this.props.close(
                        this.state.rowSelected,
                        this.state.search_result.data
                      );
                    }}
                  >
                    Chọn
                  </Button>
                )}
                <Button
                  color="success"
                  variant="contained"
                  onClick={() => this.handleClose(undefined)}
                >
                  Thoát
                </Button>
              </Stack>
            </Stack>
          </AppBar>
          <Paper variant="outlined">
            <Grid container spacing={1} columns={12}>
              <Grid item xs={1}>
                <FormLabel>Tên dữ liệu:</FormLabel>
              </Grid>
              <Grid item xs={3}>
                <OutlinedInput
                  id="sogcn"
                  fullWidth
                  autoFocus
                  value={this.state.after.ReportDataName}
                  onChange={(event) =>
                    this.saveField("ReportDataName", event.target.value)
                  }
                />
              </Grid>
              <Grid item xs={2}>
                <ButtonTimKiem
                  variant="contained"
                  disabled={this.state.search_loading}
                  startIcon={<SearchIcon fontSize="small" />}
                  onClick={this.doSearch}
                  onRightClickMenu={(item) => {
                    if (item.menuName == "CodeSearch") {
                      this.setState({ open_code_seach: true });
                    }
                    if (item.menuName == "Columns") {
                      this.setState({ open_columns_define: true });
                    }
                    if (item.menuName == "Generate") {
                      this.setState({ open_generate_code: true });
                    }
                    if (item.menuName == "GenerateJs") {
                      this.setState({ open_generate_react: true });
                    }
                  }}
                ></ButtonTimKiem>
              </Grid>
            </Grid>
          </Paper>
          <ReactDataGrid
            style={{ height: 450, fontSize: 12 }}
            showZebraRows={true}
            i18n={ReactDataGrid_i18n}
            columns={this.columns_grid}
            pagination={true}
            multiSelect={false}
            showHoverRows={false}
            checkboxColumn={{
              render: (props) => (
                <input
                  type="checkbox"
                  readOnly
                  checked={props.rowSelected}
                ></input>
              ),
            }}
            defaultLimit={10}
            limit={this.state.after.PageSize}
            skip={(this.state.after.PageIndex - 1) * this.state.after.PageSize}
            onSkipChange={(skip) => {
              this.saveField("PageIndex", skip / this.state.after.PageSize + 1);
            }}
            dataSource={this.state.search_dataSource}
            idProperty="ReportDataID"
            headerHeight={30}
            rowHeight={30}
            allowUnsort={false}
            defaultSortInfo={defaultSortInfo}
            sortInfo={this.state.sortInfo}
            onSortInfoChange={this.onSortInfoChange}
            onLimitChange={(v) => this.saveField("PageSize", v)}
            emptyText={loadDataError(
              this.state.search_error,
              this.state.search_result.data.length === 0,
              this.state.errorMessage,
              this.state.errorLog
            )}
            skipLoadOnMount={true}
            enableSelection={true}
            onSelectionChange={({ data, selected, unselected }) => {
              var now = new Date().getTime();
              var diff = now - this.lastClick;
              if (diff > 300) {
                this.setState({ rowSelected: data });
              } else {
                //double click
                this.setState(
                  {
                    rowSelected: data,
                  },
                  () => {
                    if (!this.props.disableChon) {
                      this.props.close(
                        this.state.rowSelected,
                        this.state.search_result.data
                      );
                    }
                  }
                );
              }
              this.lastClick = now;
            }}
          ></ReactDataGrid>
        </DialogContent>
        {this.state.open_code_seach ? (
          <PagingSearchCodeDialog
            open={true}
            DieuKien={this.state.after}
            gridColumns={this.columns_grid}
            close={(record) => {
              this.setState({
                open_code_seach: false,
              });
            }}
          />
        ) : null}
        {this.state.open_columns_define ? (
          <SearchFormColumnsDialog
            open={true}
            formName={this.constructor.name}
            columns_default={this.columns_grid}
            close={(record) => {
              if (record) {
                this.columns_grid = myLib.applyGridColumns(
                  default_columns_grid,
                  record
                );
              }
              this.setState({
                open_columns_define: false,
              });
            }}
          />
        ) : null}
        {this.state.open_generate_code ? (
          <GenerateCodeDialog
            open={true}
            close={(record) => {
              this.setState({
                open_generate_code: false,
              });
            }}
          />
        ) : null}
        {this.state.open_generate_react ? (
          <GenerateCodeReactDialog
            open={true}
            close={(record) => {
              this.setState({
                open_generate_react: false,
              });
            }}
          />
        ) : null}
        {this.state.showEditDialog ? (
          <ReportDataEditDialog
            open={true}
            edittingRecord={this.state.edittingRecord}
            close={(record) => {
              this.setState(
                {
                  showEditDialog: false,
                  edittingRecord: undefined,
                  rowSelected: undefined,
                },
                () => this.doSearch()
              );
            }}
          />
        ) : null}
        {this.state.showConfirmXoa ? (
          <SimpleDialog
            confirm
            message={"Bạn muốn xóa:" + this.state.rowSelected.ReportDataID + " ?"}
            open={true}
            OKRunning={this.state.saving}
            close={(ok) => {
              if (!this.state.saving) {
                if (ok) {
                  //thuc hien xoa
                  this.setState({ saving: true });
                  server
                    .post("ChiPhi/DoRequest", {
                      Function: "Proc_Report_Data_Defines_Delete",
                      ThamSo: this.state.rowSelected,
                    })
                    .then((response) => {
                      this.setState({ showConfirmXoa: false, saving: false });
                      //reload
                      this.doSearch();
                    })
                    .catch((error) => {
                      this.setState({ saving: false, showConfirmXoa: false });
                      handleServerError(error);
                    });
                } else {
                  this.setState({ showConfirmXoa: false });
                }
              }
            }}
          />
        ) : null}
        <ToastContainer
          position="top-right"
          autoClose={false}
          hideProgressBar
          newestOnTop={true}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover={false}
          style={{ fontSize: 12, width: 750 }}
          limit={5}
        />
      </Dialog>
    );
  }
}
